module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"ru":{"email":"Электронная почта","warning":"Нужно будет подтвердить после изменения","emailSaved":"Новая электронная почта сохранена. Подвердите ее с помощью ссылки в письме.","change":"Изменить","errors":{"email":{"required":"Элетронная почта обезательно нужна","email":"Электронная почта должна быть настоящей","unique":"Такой адрес элекронной почты уже используется"}}}}')
  delete Component.options._Ctor
}
